import { FC, ReactNode, useState } from 'react';

import { Box, Container } from '@mui/system';

import useAuth from '@/shared/contexts/auth/hooks/useAuth';
import useAuthGuard from '@/shared/contexts/auth/hooks/useAuthGuard';

import CustomToastContainer from './components/CustomToastContainer';
import NavBar from './components/NavBar';
import NavigationPanel from './components/NavigationPanel';

type RootLayoutProps = {
  children: ReactNode;
};

const RootLayout: FC<RootLayoutProps> = ({ children }) => {
  const { user, isLoading } = useAuth();
  useAuthGuard({ user, isLoading });

  const [isPanelOpen, setIsPanelOpen] = useState(true);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'auto minmax(470px, 1fr)',
        px: 0,
        minHeight: '100vh',
      }}
    >
      <NavigationPanel
        isPanelOpen={isPanelOpen}
        setIsPanelOpen={setIsPanelOpen}
      >
        <NavBar isDrawerOpened={isPanelOpen} />
      </NavigationPanel>

      <Container component='main' maxWidth={false} sx={{ pb: 4 }}>
        {children}
      </Container>

      <CustomToastContainer />
    </Box>
  );
};

export default RootLayout;
